import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { useParams } from 'react-router-dom';
import getBaseUrl from '../helpers/utility';


const EffectifBrigade = () => {
  const { id } = useParams();
  const baseUrl = getBaseUrl();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const [personnel, setPersonnel] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`/brigade/api/${id}/effectif`);
        setData(response.data.data);

        const personnelId = response.data.data?.brigade?.personnelId;

        if (personnelId && !isNaN(personnelId)) {
          try {
            const responsePersonnel = await axios.get(`/personnel/show/${personnelId}`);
            if (responsePersonnel?.data) {
              setPersonnel(responsePersonnel.data);
            }
          } catch (err) {
            console.warn("⚠️ Aucun personnel trouvé pour cette brigade :", err.message);
            // Optionnel : tu peux afficher un toast si tu veux prévenir l'utilisateur
            // toast.warn("Aucun chef de brigade n'est encore défini.");
          }
        } else {
          console.log("ℹ️ Aucun personnelId trouvé pour cette brigade.");
        }

        /* if (response.data.data?.brigade?.personnelId) {          
          const responsePersonnel = await axios.get(`${baseUrl}/personnel/show/${response.data.data.brigade.personnelId}`);
          responsePersonnel && setPersonnel(responsePersonnel.data);
        } */
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) {
    return <p className="container mt-5 pt-5">Chargement...</p>;
  }
  if (error) {
    return (
      <p style={{ fontSize: '40px', fontFamily: 'impact' }} className=" text-bold bg-danger container mt-5 p-2">
        {error}
      </p>
    );
  }
  console.log(personnel);
  return (
    <div className="min-h-screen bg-gray-100 p-6">
      {/* HEADER BRIGADE */}
      <div className="max-w-7xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="grid md:grid-cols-3 gap-6 p-6">

          {/* IMAGE BRIGADE */}
          <div className="md:col-span-2">
            <img
              className="w-full h-[420px] object-cover rounded-xl shadow"
              src={`${baseUrl}/images/brigades/${data.brigade?.filename}`}
              alt={data.brigade?.filename}
            />
          </div>

          {/* INFO CHEF + DETAILS */}
          <div className="flex flex-col gap-4">

            {/* CHEF CARD */}
            <div className="bg-gray-50 rounded-xl p-4 shadow-sm">
              {personnel && (
                <img
                  className="w-full h-48 object-cover rounded-lg mb-3"
                  src={`${baseUrl}/images/personnels/${personnel?.filename}`}
                  alt={personnel.filename}
                />
              )}

              <h2 className="text-xl font-bold text-red-600">
                {data?.brigadeName}
              </h2>

              <p className="text-sm text-gray-500 mt-1">
                Chef de brigade
              </p>

              <h3 className="text-lg font-semibold text-yellow-600 mt-2">
                {personnel?.nomprenom || 'Non défini'}
              </h3>

              <div className="mt-3 space-y-1 text-sm text-gray-700">
                <p>📞 {personnel?.telephone || '-'}</p>
                <p>💬 {personnel?.whatsapp || '-'}</p>
                <p>📄 {personnel?.decisionaffectation || '-'}</p>
              </div>
            </div>

            {/* BATAILLONS LIST */}
            <div className="bg-white border rounded-xl p-4 shadow-sm">
              <h3 className="font-semibold text-blue-600 mb-2">
                Bataillons
              </h3>
              <ul className="space-y-1">
                {data.brigade?.bataillons?.map((bataillon) => (
                  <li
                    key={bataillon.id}
                    className="flex items-center gap-2 text-gray-700"
                  >
                    <span className="text-blue-500">📍</span>
                    {bataillon.name}
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

        {/* REFERENCE */}
        <div className="px-6 pb-4 text-sm text-gray-600">
          <span className="font-semibold">Ref. Implantation :</span>{" "}
          {data.brigade.reference}
        </div>
      </div>

      {/* EFFECTIF SECTION */}
      <div className="max-w-7xl mx-auto mt-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          EFFECTIF
        </h2>

        <div className="space-y-8">
          {data.bataillons.map((bataillon, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md p-6"
            >
              <h3 className="text-lg font-bold text-white bg-blue-600 inline-block px-4 py-1 rounded-lg mb-4">
                {bataillon.bataillonName}
              </h3>

              {/* TABLE 1 */}
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left border rounded-lg overflow-hidden">
                  <thead className="bg-gray-900 text-white">
                    <tr>
                      <th className="p-3">Observation</th>
                      <th className="p-3">OFF</th>
                      <th className="p-3">S-OFF</th>
                      <th className="p-3">ADL</th>
                      <th className="p-3">PDL</th>
                      <th className="p-3">TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t">
                      <td className="p-3 font-medium">Nombres</td>
                      <td className="p-3">{bataillon.observations.OFF}</td>
                      <td className="p-3">{bataillon.observations['S-OFF']}</td>
                      <td className="p-3">{bataillon.observations.ADL}</td>
                      <td className="p-3">{bataillon.observations.PDL}</td>
                      <td className="p-3 font-bold">{bataillon.observations.TOTAL}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* TABLE 2 */}
              <div className="overflow-x-auto mt-4">
                <table className="w-full text-sm border rounded-lg overflow-hidden">
                  <thead className="bg-gray-100 text-gray-700">
                    <tr>
                      <th className="p-3">Compagnie</th>
                      <th className="p-3">OFF</th>
                      <th className="p-3">S-OFF</th>
                      <th className="p-3">ADL</th>
                      <th className="p-3">PDL</th>
                      <th className="p-3">TOTAL</th>
                    </tr>
                  </thead>

                  <tbody>
                    {bataillon.compagnies.map((compagnie, compIndex) => (
                      <tr
                        key={compIndex}
                        className="border-t hover:bg-gray-50 transition"
                      >
                        <td className="p-3 font-medium">
                          {compagnie.name}
                        </td>
                        <td className="p-3">{compagnie.OFF}</td>
                        <td className="p-3">{compagnie['S-OFF']}</td>
                        <td className="p-3">{compagnie.ADL}</td>
                        <td className="p-3">{compagnie.PDL}</td>
                        <td className="p-3 font-bold">{compagnie.TOTAL}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EffectifBrigade;
